import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';

// URL da API:
//   - Em desenvolvimento (local): usa localhost
//   - Em produção (Hostinger/web): usa o backend no Railway
// __DEV__ é um global injetado pelo Expo: true em dev, false no build de produção.
const BASE_URL = __DEV__
  ? 'http://localhost:3000/api'
  : 'https://ybr-backend-prodution.up.railway.app/api';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// Injeta o token JWT em todas as requisições autenticadas
api.interceptors.request.use(async (config) => {
  const token = await AsyncStorage.getItem('@ybr:token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Trata erros globais
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.error || 'Erro de conexão com o servidor';
    return Promise.reject(new Error(message));
  }
);

// ── Auth ──────────────────────────────────────────────────
export const authAPI = {
  login:    (email, senha)  => api.post('/auth/login',    { email, senha }),
  register: (data)          => api.post('/auth/register', data),
  me:       ()              => api.get('/auth/me'),
};

// ── Veículos ──────────────────────────────────────────────
export const vehiclesAPI = {
  buscar:      (params) => api.get('/vehicles',       { params }),
  detalhes:    (id)     => api.get(`/vehicles/${id}`),
  meus:        ()       => api.get('/vehicles/my/list'),
  cadastrar:   (data)   => api.post('/vehicles',      data),
};

// ── Reservas ──────────────────────────────────────────────
export const reservationsAPI = {
  criar:      (data) => api.post('/reservations',            data),
  minhas:     ()     => api.get('/reservations/my'),
  detalhes:   (id)   => api.get(`/reservations/${id}`),
  cancelar:   (id)   => api.patch(`/reservations/${id}/cancel`),
  avaliar:    (id, data) => api.post(`/reservations/${id}/review`, data),
};

// ── Matching ──────────────────────────────────────────────
export const matchingAPI = {
  buscar:    (params) => api.get('/matching',          { params }),
  confirmar: (data)   => api.post('/matching/confirm', data),
};

export default api;
